import { render, staticRenderFns } from "./CompanyWalletWorkOfficePointSearchResultBeautify.vue?vue&type=template&id=870fc810&scoped=true"
import script from "./CompanyWalletWorkOfficePointSearchResultBeautify.vue?vue&type=script&lang=js"
export * from "./CompanyWalletWorkOfficePointSearchResultBeautify.vue?vue&type=script&lang=js"
import style0 from "./CompanyWalletWorkOfficePointSearchResultBeautify.vue?vue&type=style&index=0&id=870fc810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870fc810",
  null
  
)

export default component.exports